var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGossip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 540.037,
    height: 532.965,
    viewBox: "0, 0, 540.037, 532.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.398,237.654 C513.428,237.546 514.658,234.298 514.768,234.259 C522.138,231.296 530.263,235.173 529.233,239.318 C525.503,254.322 505.063,343.484 500.063,355.154 C496.663,363.087 490.898,356.818 484.233,350.984 C483.723,350.542 493.078,320.658 493.398,319.318 C497.563,301.818 510.833,248.876 513.398,237.654",
    fill: "#D2B29A",
    id: "path83518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.398,237.654 C513.428,237.546 514.658,234.298 514.768,234.259 C522.138,231.296 530.263,235.173 529.233,239.318 C525.503,254.322 505.063,343.484 500.063,355.154 C496.663,363.087 490.898,356.818 484.233,350.984 C483.723,350.542 493.078,320.658 493.398,319.318 C497.563,301.818 510.833,248.876 513.398,237.654 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96,229.006 C24.861,228.963 25.803,235.099 25.692,235.06 C18.317,232.097 19.745,237.945 20.585,242.131 C23.393,256.099 30.139,283.982 31.835,293.381 C33.37,301.889 42.676,351.746 50.061,356.818 C50.628,357.203 60.29,360.68 60.061,359.318 C58.307,348.764 37.151,254.045 33.397,235.984 C31.581,227.243 30.176,231.59 24.96,229.006",
    fill: "#D2B29A",
    id: "path83522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96,229.006 C24.861,228.963 25.803,235.099 25.692,235.06 C18.317,232.097 19.745,237.945 20.585,242.131 C23.393,256.099 30.139,283.982 31.835,293.381 C33.37,301.889 42.676,351.746 50.061,356.818 C50.628,357.203 60.29,360.68 60.061,359.318 C58.307,348.764 37.151,254.045 33.397,235.984 C31.581,227.243 30.176,231.59 24.96,229.006 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049,466.919 C331.732,479.319 346.219,480.359 346.057,466.919 C345.897,453.484 346.057,287.31 346.057,287.31 L332.049,287.31 C332.049,287.31 332.369,454.524 332.049,466.919",
    fill: "#D6A985",
    id: "path83526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049,466.919 C331.732,479.319 346.219,480.359 346.057,466.919 C345.897,453.484 346.057,287.31 346.057,287.31 L332.049,287.31 C332.049,287.31 332.369,454.524 332.049,466.919 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.853,489.414 C378.903,483.509 412.958,479.764 399.403,459.984 C394.043,452.164 382.068,451.619 373.373,454.049 C355.423,459.049 322.924,481.914 324.994,490.644 C327.072,499.374 354.173,492.609 362.853,489.414",
    fill: "#EEA477",
    id: "path83530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.853,489.414 C378.903,483.509 412.958,479.764 399.403,459.984 C394.043,452.164 382.068,451.619 373.373,454.049 C355.423,459.049 322.924,481.914 324.994,490.644 C327.072,499.374 354.173,492.609 362.853,489.414 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.772,472.209 C355.933,475.859 386.753,467.724 390.888,457.044 C392.348,453.394 390.618,457.339 385.748,448.219 C382.323,441.804 384.238,413.126 384.023,403.068 C383.843,394.783 382.223,373.74 379.023,370.568 C368.798,360.431 350.137,373.861 352.563,393.484 C353.568,401.596 355.963,414.851 359.023,424.318 C362.753,435.874 367.063,443.434 366.073,449.824 C356.898,460.669 342.879,470.014 347.772,472.209",
    fill: "#FCE1C8",
    id: "path83534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.772,472.209 C355.933,475.859 386.753,467.724 390.888,457.044 C392.348,453.394 390.618,457.339 385.748,448.219 C382.323,441.804 384.238,413.126 384.023,403.068 C383.843,394.783 382.223,373.74 379.023,370.568 C368.798,360.431 350.137,373.861 352.563,393.484 C353.568,401.596 355.963,414.851 359.023,424.318 C362.753,435.874 367.063,443.434 366.073,449.824 C356.898,460.669 342.879,470.014 347.772,472.209 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.623,469.539 C410.913,463.439 419.588,457.129 431.963,459.449 C444.803,461.854 452.928,477.089 440.953,489.119 C433.098,497.004 417.418,502.749 400.293,505.154 C393.713,506.084 362.113,513.359 360.193,506.169 C358.133,498.409 393.828,474.664 401.623,469.539",
    fill: "#EEA477",
    id: "path83538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.623,469.539 C410.913,463.439 419.588,457.129 431.963,459.449 C444.803,461.854 452.928,477.089 440.953,489.119 C433.098,497.004 417.418,502.749 400.293,505.154 C393.713,506.084 362.113,513.359 360.193,506.169 C358.133,498.409 393.828,474.664 401.623,469.539 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.153,458.644 C402.813,442.749 384.388,402.4 386.523,385.568 C387.848,375.052 402.358,385.535 415.898,395.154 C429.353,404.715 417.418,446.614 430.683,461.459 C435.993,467.394 436.658,462.084 435.788,469.779 C434.748,478.999 418.518,485.924 406.283,485.794 C390.673,485.629 392.813,483.739 400.578,476.094 C408.378,468.414 410.403,470.604 407.153,458.644",
    fill: "#FCE1C8",
    id: "path83542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.153,458.644 C402.813,442.749 384.388,402.4 386.523,385.568 C387.848,375.052 402.358,385.535 415.898,395.154 C429.353,404.715 417.418,446.614 430.683,461.459 C435.993,467.394 436.658,462.084 435.788,469.779 C434.748,478.999 418.518,485.924 406.283,485.794 C390.673,485.629 392.813,483.739 400.578,476.094 C408.378,468.414 410.403,470.604 407.153,458.644 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033,387.337 C444.033,387.337 444.688,495.934 445.313,501.609 C442.753,509.229 435.058,508.834 431.193,502.809 C430.788,495.579 428.628,392.15 428.628,392.15 L444.033,387.337",
    fill: "#D2B29A",
    id: "path83546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.033,387.337 C444.033,387.337 444.688,495.934 445.313,501.609 C442.753,509.229 435.058,508.834 431.193,502.809 C430.788,495.579 428.628,392.15 428.628,392.15 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.708,366.423 C498.708,366.423 502.153,476.174 502.573,485.509 C501.283,496.334 488.443,496.334 487.153,485.509 C487.153,472.679 484.593,374.845 484.593,374.845 L498.708,366.423",
    fill: "#D2B29A",
    id: "path83550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.708,366.423 C498.708,366.423 502.153,476.174 502.573,485.509 C501.283,496.334 488.443,496.334 487.153,485.509 C487.153,472.679 484.593,374.845 484.593,374.845 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.868,331.529 C472.763,324.851 483.218,339.298 493.168,343.445 C499.518,346.09 510.823,353.146 504.468,363.074 C488.983,376.693 422.773,405.779 407.748,380.493 C392.158,354.306 439.973,339.558 457.868,331.529",
    fill: "#F9D6BC",
    id: "path83554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.868,331.529 C472.763,324.851 483.218,339.298 493.168,343.445 C499.518,346.09 510.823,353.146 504.468,363.074 C488.983,376.693 422.773,405.779 407.748,380.493 C392.158,354.306 439.973,339.558 457.868,331.529 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.273,384.246 C417.783,387.205 433.858,398.353 438.563,397.474 C446.578,395.974 458.888,392.801 466.313,389.318 C476.103,384.721 499.518,377.625 504.468,371.014 C506.968,367.658 507.853,357.963 505.408,353.367 C501.638,360.428 483.043,365.935 475.278,369.244 C460.703,375.451 435.743,381.59 427.273,384.246",
    fill: "#E0BEA3",
    id: "path83558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.273,384.246 C417.783,387.205 433.858,398.353 438.563,397.474 C446.578,395.974 458.888,392.801 466.313,389.318 C476.103,384.721 499.518,377.625 504.468,371.014 C506.968,367.658 507.853,357.963 505.408,353.367 C501.638,360.428 483.043,365.935 475.278,369.244 C460.703,375.451 435.743,381.59 427.273,384.246 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.793,370.131 C397.068,369.861 394.258,371.785 399.973,379.832 C404.358,386.01 425.388,394.824 435.743,397.474 C437.623,394.824 437.623,388.654 436.688,382.478 C431.983,380.711 420.233,373.914 415.973,371.889 C412.788,370.385 407.033,370.326 402.793,370.131",
    fill: "#E0BEA3",
    id: "path83562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.793,370.131 C397.068,369.861 394.258,371.785 399.973,379.832 C404.358,386.01 425.388,394.824 435.743,397.474 C437.623,394.824 437.623,388.654 436.688,382.478 C431.983,380.711 420.233,373.914 415.973,371.889 C412.788,370.385 407.033,370.326 402.793,370.131 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823,242.131 C461.328,243.131 476.328,258.971 487.568,273.474 C492.853,280.301 497.143,298.662 497.148,315.568 C497.153,330.17 501.108,338.068 493.398,349.318 C486.003,360.105 478.398,360.568 458.398,363.693 C446.928,365.486 446.523,369.943 432.148,376.193 C432.148,391.193 432.148,404.943 427.773,410.568 C415.273,416.193 400.898,406.193 384.648,401.193 C369.873,396.648 357.773,393.068 344.647,396.818 C343.397,391.818 337.772,376.193 338.397,365.568 C338.641,361.404 338.397,354.318 345.897,345.568 C354.603,335.412 360.198,333.752 372.148,319.318 C384.808,304.017 390.283,293.426 401.153,279.814 C414.453,263.181 417.003,240.959 440.823,242.131",
    fill: "#F3DCAC",
    id: "path83566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.823,242.131 C461.328,243.131 476.328,258.971 487.568,273.474 C492.853,280.301 497.143,298.662 497.148,315.568 C497.153,330.17 501.108,338.068 493.398,349.318 C486.003,360.105 478.398,360.568 458.398,363.693 C446.928,365.486 446.523,369.943 432.148,376.193 C432.148,391.193 432.148,404.943 427.773,410.568 C415.273,416.193 400.898,406.193 384.648,401.193 C369.873,396.648 357.773,393.068 344.647,396.818 C343.397,391.818 337.772,376.193 338.397,365.568 C338.641,361.404 338.397,354.318 345.897,345.568 C354.603,335.412 360.198,333.752 372.148,319.318 C384.808,304.017 390.283,293.426 401.153,279.814 C414.453,263.181 417.003,240.959 440.823,242.131 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.828,525.269 C396.733,532.654 409.233,534.319 410.678,525.269 C412.063,514.379 410.678,273.661 410.678,273.661 L395.828,273.661 C395.828,273.661 393.713,516.909 395.828,525.269",
    fill: "#D6A985",
    id: "path83570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.828,525.269 C396.733,532.654 409.233,534.319 410.678,525.269 C412.063,514.379 410.678,273.661 410.678,273.661 L395.828,273.661 C395.828,273.661 393.713,516.909 395.828,525.269 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.022,472.664 C212.561,480.154 197.803,480.174 198.1,472.664 C198.397,465.154 198.1,293.054 198.1,293.054 L213.022,293.054 C213.022,293.054 213.479,465.174 213.022,472.664",
    fill: "#D6A985",
    id: "path83574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.022,472.664 C212.561,480.154 197.803,480.174 198.1,472.664 C198.397,465.154 198.1,293.054 198.1,293.054 L213.022,293.054 C213.022,293.054 213.479,465.174 213.022,472.664 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.078,491.819 C169.297,489.154 131.981,482.164 145.541,462.389 C150.897,454.574 162.865,454.019 171.57,456.449 C189.526,461.459 222.026,484.314 219.94,493.054 C217.871,501.779 191.19,493.709 182.078,491.819",
    fill: "#FFFFFE",
    id: "path83578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.078,491.819 C169.297,489.154 131.981,482.164 145.541,462.389 C150.897,454.574 162.865,454.019 171.57,456.449 C189.526,461.459 222.026,484.314 219.94,493.054 C217.871,501.779 191.19,493.709 182.078,491.819 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.166,474.624 C189.012,478.269 158.842,469.759 154.709,459.089 C157.264,454.234 165.108,453.154 166.247,443.404 C167.579,432.029 170.779,414.943 175.594,406.113 C183.143,392.224 205.379,380.351 202.19,406.115 C199.963,424.121 185.783,437.164 182.811,455.039 C191.986,465.884 202.059,472.419 197.166,474.624",
    fill: "#FCE1C8",
    id: "path83582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.166,474.624 C189.012,478.269 158.842,469.759 154.709,459.089 C157.264,454.234 165.108,453.154 166.247,443.404 C167.579,432.029 170.779,414.943 175.594,406.113 C183.143,392.224 205.379,380.351 202.19,406.115 C199.963,424.121 185.783,437.164 182.811,455.039 C191.986,465.884 202.059,472.419 197.166,474.624 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.322,471.949 C134.026,465.839 122.104,451.424 112.26,459.089 C103.397,465.984 89.233,485.984 106.733,495.154 C116.444,500.244 128.827,504.404 140.217,506.634 C146.736,507.909 183.397,521.819 184.74,508.574 C185.549,500.584 151.108,477.069 143.322,471.949",
    fill: "#FFFFFE",
    id: "path83586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.322,471.949 C134.026,465.839 122.104,451.424 112.26,459.089 C103.397,465.984 89.233,485.984 106.733,495.154 C116.444,500.244 128.827,504.404 140.217,506.634 C146.736,507.909 183.397,521.819 184.74,508.574 C185.549,500.584 151.108,477.069 143.322,471.949 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.072,458.119 C140.404,442.224 159.951,429.349 157.826,412.517 C156.483,402.002 145.467,384.471 131.932,394.08 C118.463,403.65 124.69,441.619 115.369,456.179 C111.108,462.824 108.279,464.494 109.149,472.189 C110.19,481.409 126.424,488.324 138.661,488.199 C154.266,488.034 152.129,486.149 144.358,478.504 C136.561,470.824 132.815,470.074 136.072,458.119",
    fill: "#FCE1C8",
    id: "path83590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.072,458.119 C140.404,442.224 159.951,429.349 157.826,412.517 C156.483,402.002 145.467,384.471 131.932,394.08 C118.463,403.65 124.69,441.619 115.369,456.179 C111.108,462.824 108.279,464.494 109.149,472.189 C110.19,481.409 126.424,488.324 138.661,488.199 C154.266,488.034 152.129,486.149 144.358,478.504 C136.561,470.824 132.815,470.074 136.072,458.119 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.415,390.484 C96.415,390.484 97.04,497.869 96.415,503.554 C97.565,510.984 110.065,514.319 113.1,504.759 C113.504,497.529 111.815,391.681 111.815,391.681 L96.415,390.484",
    fill: "#D2B29A",
    id: "path83594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.415,390.484 C96.415,390.484 97.04,497.869 96.415,503.554 C97.565,510.984 110.065,514.319 113.1,504.759 C113.504,497.529 111.815,391.681 111.815,391.681 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.458,365.222 C40.458,365.222 38.807,480.824 38.397,490.154 C37.561,500.154 50.692,503.039 52.561,494.319 C54.247,479.544 55.858,374.845 55.858,374.845 L40.458,365.222",
    fill: "#D2B29A",
    id: "path83598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.458,365.222 C40.458,365.222 38.807,480.824 38.397,490.154 C37.561,500.154 50.692,503.039 52.561,494.319 C54.247,479.544 55.858,374.845 55.858,374.845 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.072,333.935 C72.178,327.253 61.717,341.706 51.776,345.849 C45.424,348.493 34.123,355.555 40.485,365.476 C55.96,379.095 122.162,408.181 137.204,382.898 C152.783,356.712 104.967,341.966 87.072,333.935",
    fill: "#F9D6BC",
    id: "path83602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.072,333.935 C72.178,327.253 61.717,341.706 51.776,345.849 C45.424,348.493 34.123,355.555 40.485,365.476 C55.96,379.095 122.162,408.181 137.204,382.898 C152.783,356.712 104.967,341.966 87.072,333.935 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.674,386.646 C127.151,389.611 111.083,400.762 106.37,399.88 C98.378,398.38 86.493,393.654 79.069,390.169 C69.286,385.579 45.424,380.033 40.485,373.419 C37.975,370.058 37.09,360.368 39.54,355.769 C43.309,362.833 61.893,368.341 69.667,371.65 C84.236,377.859 109.205,384 117.674,386.646",
    fill: "#E0BEA3",
    id: "path83606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.674,386.646 C127.151,389.611 111.083,400.762 106.37,399.88 C98.378,398.38 86.493,393.654 79.069,390.169 C69.286,385.579 45.424,380.033 40.485,373.419 C37.975,370.058 37.09,360.368 39.54,355.769 C43.309,362.833 61.893,368.341 69.667,371.65 C84.236,377.859 109.205,384 117.674,386.646 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.143,372.533 C147.872,372.264 150.682,374.193 144.967,382.236 C140.585,388.408 119.551,397.234 109.206,399.881 C107.307,397.234 107.307,391.056 108.256,384.876 C112.967,383.118 124.702,376.316 128.967,374.293 C132.147,372.79 137.909,372.728 142.143,372.533",
    fill: "#E0BEA3",
    id: "path83610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.143,372.533 C147.872,372.264 150.682,374.193 144.967,382.236 C140.585,388.408 119.551,397.234 109.206,399.881 C107.307,397.234 107.307,391.056 108.256,384.876 C112.967,383.118 124.702,376.316 128.967,374.293 C132.147,372.79 137.909,372.728 142.143,372.533 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.063,180.154 C493.298,178.222 491.358,181.68 488.443,181.986 C487.083,191.486 508.173,204.708 517.543,206.844 C526.393,208.855 541.983,213.81 538.078,202.833 C535.768,196.341 514.088,184.154 500.063,180.154",
    fill: "#F9D6BC",
    id: "path83614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.063,180.154 C493.298,178.222 491.358,181.68 488.443,181.986 C487.083,191.486 508.173,204.708 517.543,206.844 C526.393,208.855 541.983,213.81 538.078,202.833 C535.768,196.341 514.088,184.154 500.063,180.154 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.963,246.14 C529.518,238.118 538.308,219.294 528.668,208.445 C524.388,203.634 508.693,196.609 499.578,191.603 C483.713,182.911 493.573,191.751 492.303,205.701 C490.833,221.777 483.583,222.579 495.898,231.818 C503.398,237.443 508.773,240.708 520.963,246.14",
    fill: "#E0BEA3",
    id: "path83618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.963,246.14 C529.518,238.118 538.308,219.294 528.668,208.445 C524.388,203.634 508.693,196.609 499.578,191.603 C483.713,182.911 493.573,191.751 492.303,205.701 C490.833,221.777 483.583,222.579 495.898,231.818 C503.398,237.443 508.773,240.708 520.963,246.14 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.943,241.326 C530.378,245.34 519.713,247.437 520.963,245.34 C525.243,238.118 528.658,214.861 527.813,207.65 C527.368,203.853 537.438,198.927 538.928,205.236 C540.643,212.458 536.238,236.173 532.943,241.326",
    fill: "#D7B69D",
    id: "path83622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.943,241.326 C530.378,245.34 519.713,247.437 520.963,245.34 C525.243,238.118 528.658,214.861 527.813,207.65 C527.368,203.853 537.438,198.927 538.928,205.236 C540.643,212.458 536.238,236.173 532.943,241.326 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.835,179.943 C53.206,189.453 32.274,205.51 22.904,207.65 C14.057,209.661 -2.517,210.308 4.647,200.881 C9.983,193.849 42.874,179.006 51.835,179.943",
    fill: "#F9D6BC",
    id: "path83626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.835,179.943 C53.206,189.453 32.274,205.51 22.904,207.65 C14.057,209.661 -2.517,210.308 4.647,200.881 C9.983,193.849 42.874,179.006 51.835,179.943 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.209,249.005 C5.897,239.005 2.295,220.222 11.785,209.247 C19.022,200.88 31.764,197.415 40.879,192.411 C56.746,183.716 46.869,192.552 48.143,206.501 C49.611,222.579 55.672,229.189 41.736,235.719 C33.178,239.72 28.397,243.576 16.209,249.005",
    fill: "#E0BEA3",
    id: "path83630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.209,249.005 C5.897,239.005 2.295,220.222 11.785,209.247 C19.022,200.88 31.764,197.415 40.879,192.411 C56.746,183.716 46.869,192.552 48.143,206.501 C49.611,222.579 55.672,229.189 41.736,235.719 C33.178,239.72 28.397,243.576 16.209,249.005 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.115,244.536 C83.611,245.535 68.615,261.368 57.377,275.879 C47.518,288.596 39.451,325.135 48.947,338.56 C60.99,355.601 85.945,363.926 109.764,370.033 C124.135,373.719 122.26,373.66 121.316,386.877 C120.385,400.105 111.083,412.674 125.197,423.25 C143.397,441.819 188.635,425.34 208.397,414.318 C214.779,410.76 218.537,402.154 221.733,388.484 C226.346,368.713 224.397,360.314 212.561,346.818 C187.354,318.068 170.697,311.082 149.569,284.629 C136.258,267.996 127.938,243.367 104.115,244.536",
    fill: "#F6CCB8",
    id: "path83634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.115,244.536 C83.611,245.535 68.615,261.368 57.377,275.879 C47.518,288.596 39.451,325.135 48.947,338.56 C60.99,355.601 85.945,363.926 109.764,370.033 C124.135,373.719 122.26,373.66 121.316,386.877 C120.385,400.105 111.083,412.674 125.197,423.25 C143.397,441.819 188.635,425.34 208.397,414.318 C214.779,410.76 218.537,402.154 221.733,388.484 C226.346,368.713 224.397,360.314 212.561,346.818 C187.354,318.068 170.697,311.082 149.569,284.629 C136.258,267.996 127.938,243.367 104.115,244.536 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.249,163.074 C229.96,169.318 224.088,183.939 212.874,185.967 C206.385,187.146 208.62,194.939 205.038,201.232 C199.151,211.579 189.432,208.888 188.745,200.818 C188.264,195.273 198.981,183.04 196.169,178.542 C193.075,173.592 191.766,156.492 193.694,142.036 C194.93,132.753 189.346,117.99 193.397,116.505 C198.653,116.126 201.715,119.558 202.772,125.568 C203.975,132.408 202.782,142.208 202.792,146.921 C218.356,133.962 226.835,143.693 222.147,154.005 C220.292,160.814 222.155,159.363 225.249,163.074",
    fill: "#FCE1C8",
    id: "path83638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.249,163.074 C229.96,169.318 224.088,183.939 212.874,185.967 C206.385,187.146 208.62,194.939 205.038,201.232 C199.151,211.579 189.432,208.888 188.745,200.818 C188.264,195.273 198.981,183.04 196.169,178.542 C193.075,173.592 191.766,156.492 193.694,142.036 C194.93,132.753 189.346,117.99 193.397,116.505 C198.653,116.126 201.715,119.558 202.772,125.568 C203.975,132.408 202.782,142.208 202.792,146.921 C218.356,133.962 226.835,143.693 222.147,154.005 C220.292,160.814 222.155,159.363 225.249,163.074 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.232,166.818 C38.99,174.681 35.897,190.152 36.732,208.484 C37.803,232.107 48.838,276.551 46.732,290.984 C64.969,291.99 121.609,275.158 132.772,258.693 C129.221,245.642 126.065,243.732 132.919,226.892 C171.426,227.693 146.154,201.275 141.465,187.599 C134.397,167 115.131,140.431 88.846,140.779 C67.834,141.051 52.561,154.318 44.232,166.818",
    fill: "#F1B3AC",
    id: "path83642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.232,166.818 C38.99,174.681 35.897,190.152 36.732,208.484 C37.803,232.107 48.838,276.551 46.732,290.984 C64.969,291.99 121.609,275.158 132.772,258.693 C129.221,245.642 126.065,243.732 132.919,226.892 C171.426,227.693 146.154,201.275 141.465,187.599 C134.397,167 115.131,140.431 88.846,140.779 C67.834,141.051 52.561,154.318 44.232,166.818 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.335,155.256 C139.878,171.303 139.958,185.738 149.647,200.881 C157.346,212.908 161.004,217.181 168.71,221.193 C175.555,212.365 184.315,202.189 186.889,185.349 C191.46,185.705 213.881,194.291 215.76,198.767 C206.686,216.287 204.452,217.832 197.057,231.701 C190.213,244.537 188.753,258.146 170.096,254.558 C150.389,250.764 149.335,242.56 131.835,234.943",
    fill: "#F1B3AC",
    id: "path83646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.335,155.256 C139.878,171.303 139.958,185.738 149.647,200.881 C157.346,212.908 161.004,217.181 168.71,221.193 C175.555,212.365 184.315,202.189 186.889,185.349 C191.46,185.705 213.881,194.291 215.76,198.767 C206.686,216.287 204.452,217.832 197.057,231.701 C190.213,244.537 188.753,258.146 170.096,254.558 C150.389,250.764 149.335,242.56 131.835,234.943",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.213,27.566 C80.203,24.783 83.875,22.341 88.342,20.365 C120.438,6.111 157.301,28.626 162.861,62.499 C165.897,80.984 167.303,93.107 163.397,109.318 C159.729,124.538 152.274,133.849 141.857,139.083 C135.815,142.122 132.756,140.927 117.502,135.47 C114.647,141.818 112.377,144.292 113.225,152.312 C129.486,165.945 117.965,174.544 107.772,171.818 C89.805,167.005 72.756,150.898 72.701,142.421 C82.274,141.263 93.836,128.159 92.438,118.843 C90.881,108.419 74.662,101.224 71.402,90.509 C64.9,69.236 60.672,42.97 77.213,27.566",
    fill: "#FCE1C8",
    id: "path83650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.213,27.566 C80.203,24.783 83.875,22.341 88.342,20.365 C120.438,6.111 157.301,28.626 162.861,62.499 C165.897,80.984 167.303,93.107 163.397,109.318 C159.729,124.538 152.274,133.849 141.857,139.083 C135.815,142.122 132.756,140.927 117.502,135.47 C114.647,141.818 112.377,144.292 113.225,152.312 C129.486,165.945 117.965,174.544 107.772,171.818 C89.805,167.005 72.756,150.898 72.701,142.421 C82.274,141.263 93.836,128.159 92.438,118.843 C90.881,108.419 74.662,101.224 71.402,90.509 C64.9,69.236 60.672,42.97 77.213,27.566 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.561,131.818 C63.83,129.986 55.061,123.484 48.201,112.076 C51.815,116.303 65.08,119.943 67.41,111.413 C69.67,103.127 63.555,98.79 58.426,92.176 C52.154,84.097 49.08,71.568 49.045,61.707 C48.947,29.668 75.971,2.363 111.057,0.75 C128.022,-0.024 165.666,10.115 175.876,36.236 C179.294,44.98 177.52,64.036 163.397,67.652 C159.551,53.816 148.406,43.004 145.32,41.346 C146.289,44.798 148.217,47.982 150.041,51.127 C140.094,51.543 118.445,46.971 111.621,39.441 C114.266,45.537 118.824,51.129 124.246,55.255 C119.162,55.314 113.264,51.33 108.569,49.678 C102.881,47.67 97.838,45.144 93.041,41.51 C101.024,47.553 94.279,67.722 92.807,75.301 C89.863,90.254 89.772,102.918 101.209,115.079 C97.65,114.937 93.524,114.338 90.516,112.617 C93.082,118.631 95.213,122.615 99.5,126.452 C99.315,126.283 90.061,133.484 77.561,131.818",
    fill: "#78442D",
    id: "path83654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.561,131.818 C63.83,129.986 55.061,123.484 48.201,112.076 C51.815,116.303 65.08,119.943 67.41,111.413 C69.67,103.127 63.555,98.79 58.426,92.176 C52.154,84.097 49.08,71.568 49.045,61.707 C48.947,29.668 75.971,2.363 111.057,0.75 C128.022,-0.024 165.666,10.115 175.876,36.236 C179.294,44.98 177.52,64.036 163.397,67.652 C159.551,53.816 148.406,43.004 145.32,41.346 C146.289,44.798 148.217,47.982 150.041,51.127 C140.094,51.543 118.445,46.971 111.621,39.441 C114.266,45.537 118.824,51.129 124.246,55.255 C119.162,55.314 113.264,51.33 108.569,49.678 C102.881,47.67 97.838,45.144 93.041,41.51 C101.024,47.553 94.279,67.722 92.807,75.301 C89.863,90.254 89.772,102.918 101.209,115.079 C97.65,114.937 93.524,114.338 90.516,112.617 C93.082,118.631 95.213,122.615 99.5,126.452 C99.315,126.283 90.061,133.484 77.561,131.818 z M155.584,65.256 C152.652,54.451 140.691,58.025 141.834,68.068 M128.084,70.256 C122.459,56.193 107.684,64.693 108.094,73.728",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.334,79.006 C146.18,79.637 148.401,85.286 150.272,84.943 C153.709,84.318 152.459,78.381 149.334,79.006",
    fill: "#1A1919",
    id: "path83658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.772,82.443 C119.96,82.443 119.029,88.626 122.46,89.005 C125.272,89.318 125.585,82.443 122.772,82.443",
    fill: "#1A1919",
    id: "path83660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.522,241.818 C131.21,235.255 137.397,230.052 139.96,219.63 C142.327,210.017 132.659,200.829 131.592,190.808",
    fill: "#F1B3AC",
    id: "path83662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.522,241.818 C131.21,235.255 137.397,230.052 139.96,219.63 C142.327,210.017 132.659,200.829 131.592,190.808",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.368,179.779 C274.734,183.243 276.484,184.704 280.483,187.234 C284.963,190.074 293.166,192.788 297.983,193.904 C302.372,194.918 312.826,195.384 316.834,197.443 C319.901,199.017 326.123,204.685 328.979,205.544 C342.126,209.548 334.768,194.431 331.209,189.005 C329.807,186.87 326.904,179.845 327.147,177.443 C327.768,171.257 329.122,166.745 328.709,159.318 C328.407,153.835 324.022,147.443 319.861,153.919 C316.981,158.396 320.111,167.886 314.334,169.943 C312.001,169.802 305.295,165.9 299.022,163.38 C291.694,160.437 284.666,159.076 281.557,163.074 C275.984,161.835 270.419,164.93 275.368,169.88 C268.561,170.497 269.799,177.305 275.368,179.779",
    fill: "#FCE1C8",
    id: "path83666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.368,179.779 C274.734,183.243 276.484,184.704 280.483,187.234 C284.963,190.074 293.166,192.788 297.983,193.904 C302.372,194.918 312.826,195.384 316.834,197.443 C319.901,199.017 326.123,204.685 328.979,205.544 C342.126,209.548 334.768,194.431 331.209,189.005 C329.807,186.87 326.904,179.845 327.147,177.443 C327.768,171.257 329.122,166.745 328.709,159.318 C328.407,153.835 324.022,147.443 319.861,153.919 C316.981,158.396 320.111,167.886 314.334,169.943 C312.001,169.802 305.295,165.9 299.022,163.38 C291.694,160.437 284.666,159.076 281.557,163.074 C275.984,161.835 270.419,164.93 275.368,169.88 C268.561,170.497 269.799,177.305 275.368,179.779 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.523,174.318 C503.903,178.122 510.698,194.818 507.268,211.656 C502.708,234.064 488.443,262.976 494.858,289.443 C476.628,290.447 419.563,287.447 408.398,270.984 C411.943,257.931 414.853,251.747 408.003,234.908 C369.493,235.719 394.758,209.297 399.448,195.618 C406.518,175.015 425.803,147.697 452.068,148.795 C464.648,149.318 489.023,154.318 501.523,174.318",
    fill: "#F3DCAC",
    id: "path83670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.523,174.318 C503.903,178.122 510.698,194.818 507.268,211.656 C502.708,234.064 488.443,262.976 494.858,289.443 C476.628,290.447 419.563,287.447 408.398,270.984 C411.943,257.931 414.853,251.747 408.003,234.908 C369.493,235.719 394.758,209.297 399.448,195.618 C406.518,175.015 425.803,147.697 452.068,148.795 C464.648,149.318 489.023,154.318 501.523,174.318 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.104,526.004 C145.897,535.154 135.061,533.484 134.254,526.004 C132.869,515.119 135.897,275.154 135.897,275.154 L151.733,275.154 C151.733,275.154 151.221,517.644 149.104,526.004",
    fill: "#D6A985",
    id: "path83674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.104,526.004 C145.897,535.154 135.061,533.484 134.254,526.004 C132.869,515.119 135.897,275.154 135.897,275.154 L151.733,275.154 C151.733,275.154 151.221,517.644 149.104,526.004 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.893,302.892 C509.428,332.865 403.858,350.755 271.604,350.755 C139.338,350.755 32.957,331.326 30.49,302.892 C27.307,266.095 136.072,269.845 268.319,269.845 C400.578,269.845 515.183,262.931 511.893,302.892",
    fill: "#E2B18B",
    id: "path83678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.893,302.892 C509.428,332.865 403.858,350.755 271.604,350.755 C139.338,350.755 32.957,331.326 30.49,302.892 C27.307,266.095 136.072,269.845 268.319,269.845 C400.578,269.845 515.183,262.931 511.893,302.892 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.063,292.142 C511.063,315.001 403.858,335.174 271.604,335.174 C139.338,335.174 32.958,315.001 32.958,292.142 C32.958,269.273 139.338,249.958 271.604,249.958 C403.858,249.958 511.063,269.273 511.063,292.142",
    fill: "#F9D5A9",
    id: "path83682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.063,292.142 C511.063,315.001 403.858,335.174 271.604,335.174 C139.338,335.174 32.958,315.001 32.958,292.142 C32.958,269.273 139.338,249.958 271.604,249.958 C403.858,249.958 511.063,269.273 511.063,292.142 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.583,155.881 C409.688,162.039 397.948,197.262 383.398,208.484 C374.258,215.543 370.348,220.471 362.643,224.486 C355.793,215.662 346.387,202.834 336.971,186.799 C332.397,187.146 313.193,201.562 311.303,206.043 C326.637,212.4 334.709,230.662 342.115,244.537 C348.947,257.365 355.803,264.584 368.648,258.166 C385.313,249.834 387.898,242.424 406.733,236.818",
    fill: "#F3DCAC",
    id: "path83686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.583,155.881 C409.688,162.039 397.948,197.262 383.398,208.484 C374.258,215.543 370.348,220.471 362.643,224.486 C355.793,215.662 346.387,202.834 336.971,186.799 C332.397,187.146 313.193,201.562 311.303,206.043 C326.637,212.4 334.709,230.662 342.115,244.537 C348.947,257.365 355.803,264.584 368.648,258.166 C385.313,249.834 387.898,242.424 406.733,236.818",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.478,210.052 C399.083,209.49 404.983,182.708 402.148,168.381 C395.583,165.256 360.508,153.92 355.583,170.954 C356.228,192.611 361.708,210.685 381.478,210.052",
    fill: "#F6CFC8",
    id: "path83690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.478,210.052 C399.083,209.49 404.983,182.708 402.148,168.381 C395.583,165.256 360.508,153.92 355.583,170.954 C356.228,192.611 361.708,210.685 381.478,210.052 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.018,169.154 C399.823,178.064 354.108,181.685 354.948,169.154 C355.803,156.326 404.578,158.732 402.018,169.154",
    fill: "#FFFFFE",
    id: "path83694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.018,169.154 C399.823,178.064 354.108,181.685 354.948,169.154 C355.803,156.326 404.578,158.732 402.018,169.154 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.978,280.618 C428.978,289.661 407.143,296.986 380.198,296.986 C353.258,296.986 331.415,289.661 331.415,280.618 C331.415,271.588 353.258,264.265 380.198,264.265 C407.143,264.265 428.978,271.588 428.978,280.618",
    fill: "#FFFFFE",
    id: "path83698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.978,280.618 C428.978,289.661 407.143,296.986 380.198,296.986 C353.258,296.986 331.415,289.661 331.415,280.618 C331.415,271.588 353.258,264.265 380.198,264.265 C407.143,264.265 428.978,271.588 428.978,280.618 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.811,277.418 C352.373,291.048 398.588,289.443 404.578,280.618",
    fill: "#FFFFFE",
    id: "path83702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.811,277.418 C352.373,291.048 398.588,289.443 404.578,280.618",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.698,35.584 C460.713,32.801 457.033,30.361 452.568,28.387 C420.478,14.129 384.038,36.83 378.048,70.523 C376.343,80.142 372.563,98.732 375.483,116.232 C378.293,133.055 385.603,141.478 396.018,146.701 C402.068,149.742 408.153,148.947 423.403,143.493 C428.538,149.911 428.538,152.312 427.688,160.334 C413.128,181.181 432.478,200.437 455.898,179.943 C470.898,166.818 470.748,152.439 462.148,150.881 C452.573,149.722 447.078,136.178 448.483,126.857 C450.028,116.443 466.253,109.24 469.513,98.531 C476.008,77.254 480.238,50.99 463.698,35.584",
    fill: "#FCE1C8",
    id: "path83706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.698,35.584 C460.713,32.801 457.033,30.361 452.568,28.387 C420.478,14.129 384.038,36.83 378.048,70.523 C376.343,80.142 372.563,98.732 375.483,116.232 C378.293,133.055 385.603,141.478 396.018,146.701 C402.068,149.742 408.153,148.947 423.403,143.493 C428.538,149.911 428.538,152.312 427.688,160.334 C413.128,181.181 432.478,200.437 455.898,179.943 C470.898,166.818 470.748,152.439 462.148,150.881 C452.573,149.722 447.078,136.178 448.483,126.857 C450.028,116.443 466.253,109.24 469.513,98.531 C476.008,77.254 480.238,50.99 463.698,35.584 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.618,122.65 C491.013,113.023 496.193,86.67 495.288,68.92 C493.573,35.234 473.038,7.168 437.953,5.564 C420.988,4.787 377.188,11.178 366.983,37.303 C363.573,46.049 364.853,64.08 376.343,71.316 C379.333,63.381 386.608,51.267 398.588,48.865 C398.688,52.248 393.813,59.207 393.458,62.5 C401.528,63.002 424.143,59.154 428.443,50.781 C426.943,53.699 425.713,56.777 424.788,59.918 C432.738,61.596 442.013,53.955 447.873,49.527 C440.153,55.365 450.408,85.873 449.933,93.771 C449.078,108.209 447.968,117.781 434.528,125.853 C445.658,129.865 460.293,126.832 469.618,122.65",
    fill: "#8E614B",
    id: "path83710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.618,122.65 C491.013,113.023 496.193,86.67 495.288,68.92 C493.573,35.234 473.038,7.168 437.953,5.564 C420.988,4.787 377.188,11.178 366.983,37.303 C363.573,46.049 364.853,64.08 376.343,71.316 C379.333,63.381 386.608,51.267 398.588,48.865 C398.688,52.248 393.813,59.207 393.458,62.5 C401.528,63.002 424.143,59.154 428.443,50.781 C426.943,53.699 425.713,56.777 424.788,59.918 C432.738,61.596 442.013,53.955 447.873,49.527 C440.153,55.365 450.408,85.873 449.933,93.771 C449.078,108.209 447.968,117.781 434.528,125.853 C445.658,129.865 460.293,126.832 469.618,122.65 z M384.043,79.344 C383.888,69.006 396.883,72.127 397.733,77.734 M412.278,78.537 C415.698,69.721 428.323,69.959 430.898,81.193",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.208,87.443 C393.578,88.068 393.103,95.014 390.273,94.006 C387.438,93.002 388.518,86.734 391.208,87.443",
    fill: "#1A1919",
    id: "path83714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.023,89.318 C421.973,89.023 422.683,96.126 419.333,96.193 C415.098,96.279 415.898,89.631 419.023,89.318",
    fill: "#1A1919",
    id: "path83716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.773,109.005 C390.898,109.943 389.463,105.501 386.833,107.443 C384.938,110.613 385.928,114.31 389.173,116.232 M397.948,125.247 C401.153,128.861 404.153,131.447 409.498,130.06 C413.383,129.06 415.918,122.845 413.998,118.63",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.898,245.152 C406.733,237.652 399.013,230.372 400.898,216.818 C402.258,207.029 408.648,197.626 409.713,187.599",
    fill: "#F3DCAC",
    id: "path83720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.898,245.152 C406.733,237.652 399.013,230.372 400.898,216.818 C402.258,207.029 408.648,197.626 409.713,187.599",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.648,233.904 C436.433,240.722 442.168,244.089 444.023,233.068 C444.438,230.591 441.413,218.142 441.523,214.943 C441.823,205.847 436.768,196.576 430.898,189.318 C424.668,181.62 417.238,176.158 404.023,174.318 C402.123,173.435 392.458,172.755 396.523,179.943 C389.958,178.693 386.013,185.974 394.568,189.533 C392.663,191.324 392.663,193.103 396.468,197.56 C396.423,206.056 400.453,209.122 407.658,213.347 C414.573,217.398 424.063,219.771 425.898,221.404 C428.398,227.654 425.438,229.675 429.648,233.904",
    fill: "#FCE1C8",
    id: "path83724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.648,233.904 C436.433,240.722 442.168,244.089 444.023,233.068 C444.438,230.591 441.413,218.142 441.523,214.943 C441.823,205.847 436.768,196.576 430.898,189.318 C424.668,181.62 417.238,176.158 404.023,174.318 C402.123,173.435 392.458,172.755 396.523,179.943 C389.958,178.693 386.013,185.974 394.568,189.533 C392.663,191.324 392.663,193.103 396.468,197.56 C396.423,206.056 400.453,209.122 407.658,213.347 C414.573,217.398 424.063,219.771 425.898,221.404 C428.398,227.654 425.438,229.675 429.648,233.904 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.523,177.443 C476.388,181.462 473.038,202.029 467.903,211.656 C464.703,217.658 462.308,225.681 456.313,239.318 C453.813,230.568 451.463,222.449 449.648,214.943 C442.543,217.908 424.023,226.818 418.398,233.693 C424.138,239.745 422.368,238.24 425.483,245.568 C430.758,258.04 430.483,280.568 444.648,282.654 C448.123,283.163 455.018,282.185 460.483,278.068 C471.753,269.587 483.298,230.906 494.433,222.879",
    fill: "#F3DCAC",
    id: "path83728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.523,177.443 C476.388,181.462 473.038,202.029 467.903,211.656 C464.703,217.658 462.308,225.681 456.313,239.318 C453.813,230.568 451.463,222.449 449.648,214.943 C442.543,217.908 424.023,226.818 418.398,233.693 C424.138,239.745 422.368,238.24 425.483,245.568 C430.758,258.04 430.483,280.568 444.648,282.654 C448.123,283.163 455.018,282.185 460.483,278.068 C471.753,269.587 483.298,230.906 494.433,222.879",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.897,171.818 C113.084,174.631 104.115,173.166 101.522,174.318 C97.694,176.023 102.186,182.826 103.348,184.392 C96.317,185.627 77.977,170.681 72.408,165.334 C57.99,151.512 64.022,137.131 80.272,138.693 C71.713,146.713 82.186,157.951 84.96,159.943 C96.085,167.963 103.397,169.943 115.897,171.818",
    fill: "#FFFFFE",
    id: "path83732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.897,171.818 C113.084,174.631 104.115,173.166 101.522,174.318 C97.694,176.023 102.186,182.826 103.348,184.392 C96.317,185.627 77.977,170.681 72.408,165.334 C57.99,151.512 64.022,137.131 80.272,138.693 C71.713,146.713 82.186,157.951 84.96,159.943 C96.085,167.963 103.397,169.943 115.897,171.818 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.397,144.63 C112.772,147.443 112.147,151.505 113.71,153.38 C117.772,160.255 118.71,164.63 114.96,172.443 C120.272,170.88 122.072,165.992 122.178,165.945 C126.522,164.005 127.335,172.206 126.21,177.13 C130.272,173.693 132.881,170.857 130.936,162.359 C129.022,154.005 118.348,147.245 113.397,144.63",
    fill: "#FFFFFE",
    id: "path83736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.397,144.63 C112.772,147.443 112.147,151.505 113.71,153.38 C117.772,160.255 118.71,164.63 114.96,172.443 C120.272,170.88 122.072,165.992 122.178,165.945 C126.522,164.005 127.335,172.206 126.21,177.13 C130.272,173.693 132.881,170.857 130.936,162.359 C129.022,154.005 118.348,147.245 113.397,144.63 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.981,275.814 C241.981,284.842 220.137,292.17 193.212,292.17 C166.264,292.17 144.422,284.842 144.422,275.814 C144.422,266.773 166.264,259.443 193.212,259.443 C220.137,259.443 241.981,266.773 241.981,275.814",
    fill: "#FFFFFE",
    id: "path83740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.981,275.814 C241.981,284.842 220.137,292.17 193.212,292.17 C166.264,292.17 144.422,284.842 144.422,275.814 C144.422,266.773 166.264,259.443 193.212,259.443 C220.137,259.443 241.981,266.773 241.981,275.814 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.826,274.207 C151.209,288.068 214.383,287.036 219.303,275.808",
    fill: "#FFFFFE",
    id: "path83744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.826,274.207 C151.209,288.068 214.383,287.036 219.303,275.808",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.561,281.023 C201.432,280.736 208.631,277.117 212.147,269.734 C215.608,262.469 213.194,250.019 212.772,242.859 C212.561,234.943 203.069,233.875 193.811,233.277 C182.456,232.54 169.823,235.947 167.116,245.34 C168.817,263.783 172.801,281.654 192.561,281.023",
    fill: "#F6CFC8",
    id: "path83748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.561,281.023 C201.432,280.736 208.631,277.117 212.147,269.734 C215.608,262.469 213.194,250.019 212.772,242.859 C212.561,234.943 203.069,233.875 193.811,233.277 C182.456,232.54 169.823,235.947 167.116,245.34 C168.817,263.783 172.801,281.654 192.561,281.023 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.561,240.152 C211.624,249.884 166.317,256.074 167.147,242.652 C167.987,228.906 213.608,229.318 212.561,240.152",
    fill: "#FFFFFE",
    id: "path83752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.561,240.152 C211.624,249.884 166.317,256.074 167.147,242.652 C167.987,228.906 213.608,229.318 212.561,240.152 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.522,244.943 C214.022,245.152 218.412,247.263 219.647,253.068 C221.219,260.408 220.373,266.667 216.936,269.943 C213.992,272.751 207.322,276.511 206.732,268.068 C206.482,264.466 209.186,264.88 211.522,263.068 C212.537,262.283 213.289,260.144 213.186,258.693 C212.982,255.777 211.795,255.046 209.857,255.152 C207.479,255.279 205.77,255.997 205.061,252.027 C204.201,247.167 207.252,244.589 211.522,244.943",
    fill: "#F6CFC8",
    id: "path83756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.522,244.943 C214.022,245.152 218.412,247.263 219.647,253.068 C221.219,260.408 220.373,266.667 216.936,269.943 C213.992,272.751 207.322,276.511 206.732,268.068 C206.482,264.466 209.186,264.88 211.522,263.068 C212.537,262.283 213.289,260.144 213.186,258.693 C212.982,255.777 211.795,255.046 209.857,255.152 C207.479,255.279 205.77,255.997 205.061,252.027 C204.201,247.167 207.252,244.589 211.522,244.943 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.482,269.529 C183.397,272.859 191.107,285.154 192.982,291.404 C193.49,293.099 192.772,296.193 189.232,297.443 C189.315,299.497 185.574,304.318 183.186,304.318 C183.811,307.234 178.731,311.911 175.272,310.779 C168.397,315.779 166.688,312.474 161.922,306.238 C151.473,309.802 127.147,294.762 121.701,287.49 C118.25,282.847 116.258,283.064 119.647,278.172 C126.01,269.021 131.113,276.884 139.436,276.654 C148.279,276.402 154.266,269.548 163.113,269.22 C165.408,269.15 168.414,268.993 170.482,269.529",
    fill: "#FCE1C8",
    id: "path83760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.482,269.529 C183.397,272.859 191.107,285.154 192.982,291.404 C193.49,293.099 192.772,296.193 189.232,297.443 C189.315,299.497 185.574,304.318 183.186,304.318 C183.811,307.234 178.731,311.911 175.272,310.779 C168.397,315.779 166.688,312.474 161.922,306.238 C151.473,309.802 127.147,294.762 121.701,287.49 C118.25,282.847 116.258,283.064 119.647,278.172 C126.01,269.021 131.113,276.884 139.436,276.654 C148.279,276.402 154.266,269.548 163.113,269.22 C165.408,269.15 168.414,268.993 170.482,269.529 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.411,183.589 C72.542,187.599 85.256,241.249 91.733,250.154 C98.397,259.318 108.397,264.318 134.149,269.392 C136.733,280.154 137.184,289.048 130.736,301.472 C121.317,304.681 88.647,293.24 79.233,286.818 C55.322,270.521 61.815,250.144 47.733,227.693",
    fill: "#F1B3AC",
    id: "path83764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.411,183.589 C72.542,187.599 85.256,241.249 91.733,250.154 C98.397,259.318 108.397,264.318 134.149,269.392 C136.733,280.154 137.184,289.048 130.736,301.472 C121.317,304.681 88.647,293.24 79.233,286.818 C55.322,270.521 61.815,250.144 47.733,227.693",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.647,124.63 C132.46,126.818 139.292,125.853 145.067,118.034 C139.292,118.63 130.897,116.818 127.098,108.411 C125.174,114.423 126.004,121.798 129.647,124.63",
    fill: "#EFA696",
    id: "path83768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.647,124.631 C132.459,126.818 139.291,125.853 145.066,118.034 C139.291,118.631 130.897,116.818 127.098,108.411 C125.174,114.424 126.004,121.799 129.647,124.631 z M149.569,98.181 C151.834,99.943 153.084,100.568 155.979,100.587 C154.701,104.197 154.057,105.4 152.129,107.806",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.483,235.984 C458.043,248.013 458.378,252.224 459.233,262.654",
    fill: "#FFFFFE",
    id: "path83772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.483,235.984 C458.043,248.013 458.378,252.224 459.233,262.654 M180.483,284.318 C188.084,290.56 188.186,293.484 189.233,297.234 M173.397,289.529 C178.497,293.279 181.776,298.576 183.397,304.63 M166.688,298.21 C171.514,301.189 176.221,305.632 175.272,310.984 M396.468,179.734 C405.973,182.415 409.783,182.409 415.488,185.974 M394.333,189.318 C403.848,191.101 407.878,191.324 412.633,194.888",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.423,197.144 C403.338,199.572 405.023,201.12 407.878,202.908",
    fill: "#FFFFFE",
    id: "path83776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.423,197.144 C403.338,199.572 405.023,201.12 407.878,202.908",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.522,163.068 C288.946,165.131 292.639,165.618 300.061,169.734",
    fill: "#FFFFFE",
    id: "path83780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.522,163.068 C288.946,165.131 292.639,165.618 300.061,169.734",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.959,169.943 C283.458,171.915 288.397,172.654 295.061,175.154",
    fill: "#FFFFFE",
    id: "path83784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.959,169.943 C283.458,171.915 288.397,172.654 295.061,175.154",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.334,179.005 C283.811,180.568 287.565,181.404 291.732,182.234",
    fill: "#FFFFFE",
    id: "path83788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.334,179.005 C283.811,180.568 287.565,181.404 291.732,182.234",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.772,151.935 C222.215,156.568 218.221,159.779 213.17,160.697 C208.776,162.377 204.305,165.537 205.897,161.506 C208.334,159.533 211.018,150.701 215.35,147.605",
    fill: "#FCE1C8",
    id: "path83792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.772,151.935 C222.215,156.568 218.221,159.779 213.17,160.697 C208.776,162.377 204.305,165.537 205.897,161.506 C208.334,159.533 211.018,150.701 215.35,147.605",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.334,169.631 C213.77,176.685 220.963,175.711 223.635,172.892 C227.416,168.914 230.854,163.724 224.647,160.568",
    fill: "#FCE1C8",
    id: "path83796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.334,169.631 C213.77,176.685 220.963,175.711 223.635,172.892 C227.416,168.914 230.854,163.724 224.647,160.568",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.785,248.497 C15.916,251.622 21.1,247.639 18.628,241.286 C15.209,232.461 14.358,215.621 14.358,207.597 C14.358,203.786 6.647,197.173 3.225,202.79 C-2.578,212.298 2.369,241.375 11.785,248.497",
    fill: "#D7B69D",
    id: "path83800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.785,248.497 C15.916,251.622 21.1,247.639 18.628,241.286 C15.209,232.461 14.358,215.621 14.358,207.597 C14.358,203.786 6.647,197.173 3.225,202.79 C-2.578,212.298 2.369,241.375 11.785,248.497 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.397,170.255 C216.834,172.443 231.462,163.367 222.799,156.56 C215.658,157.072 204.842,164.812 213.397,170.255",
    fill: "#FCE1C8",
    id: "path83804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.397,170.255 C216.834,172.443 231.462,163.367 222.799,156.56 C215.658,157.072 204.842,164.812 213.397,170.255 z",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.338,157.456 C202.654,156.074 207.229,156.005 210.574,154.212 C216.623,150.974 224.803,152.574 226.131,155.021 C227.723,160.599 225.268,167.173 214.031,163.933 C210.574,169.603 210.096,171.031 203.66,174.471",
    fill: "#FCE1C8",
    id: "path83808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.338,157.457 C202.654,156.074 207.229,156.006 210.575,154.213 C216.623,150.974 224.803,152.574 226.131,155.021 C227.723,160.599 225.268,167.174 214.032,163.933 C210.575,169.603 210.096,171.031 203.661,174.471 M438.398,359.943 C434.023,366.193 433.398,368.693 432.148,375.568",
    fillOpacity: 0,
    stroke: "#1A1919",
    strokeWidth: 1.418,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path83810"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGossip);
export default __webpack_public_path__ + "static/media/gossip.f70a43f11eb1173a269e641c4a18d159.svg";
export { ForwardRef as ReactComponent };